module.exports = __webpack_public_path__ + "img/print_filled_64.9d009682.svg";